module.exports = __webpack_public_path__ + "static/media/HB_greeksalad_forweb2_edited.2afa9695.jpg";